"use client"

import { BadgeX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeXIcon = component(Icon)({ as: BadgeX })
